import React, { useState } from "react";
import { BnbLabel } from "../../../utils/labels";
import { Container } from "../../../../../../common-deprecated/styles/v2/toyota/globals/Container";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as IconWrapper from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import * as Type from "../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import * as BasketStyles from "../../../../../../common-deprecated/styles/v2/toyota/custom/basket/Basket";
import * as Styles from "./styles/Summary";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import DisclaimerContainer from "../common/disclaimer/DisclaimerContainer";
import useSummaryExtra from "../../../hooks/shared/extras/useSummaryExtra";
import CategorizedExtras from "../common/extras/CategorizedExtras";
import MiniCarHero from "../common/MiniCarHero";
import SummarySpecs from "./SummarySpecs";
import SummaryTaxAndCosts from "./SummaryTaxAndCosts";
import useInitSummary from "../../../hooks/summary/useInitSummary";
import SidebarWrapper from "../../../../../../common-deprecated/components/SidebarWrapper";
import Basket from "../common/basket/Basket";
import BottomNavigation from "../common/nav/BottomNavigation";
import SummaryDetails from "./SummaryDetails";
import { GreyBackground } from "../../../../../../common-deprecated/styles/v2/toyota/utilities/Background";
import { useBnbSelector } from "../../../redux/store";
import BasketFinanceTogglePanel from "../common/basket-financetoggle-panel/BasketFinanceTogglePanel";
import { NAV_HEIGHT } from "../../../../../../common-deprecated/styles/v2/toyota/components/Navigation";
import { isPassiveSummary } from "../../../utils/settings/bnbSettingUtils";

const SummaryContainer = (): JSX.Element => {
    useInitSummary();

    const { categories, removeExtra, basketExtras } = useSummaryExtra();
    const [showExtras, setShowExtras] = useState(true);

    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const passiveSummary = isPassiveSummary(commonSettings);

    return (
        <>
            <Container mt={5}>
                <MiniCarHero />
            </Container>
            <GreyBackground>
                <Container mt={4}>
                    <Flex.Row justifyContent="flex-start">
                        <Flex.Col width={{ xs: 1, lg: 2 / 3 }} pt={5}>
                            <SummaryDetails />
                            {basketExtras.length ? (
                                <>
                                    <Styles.Title pt={3} pb={2} onClick={() => setShowExtras(!showExtras)}>
                                        <Type.Strong m={0}>
                                            <BnbLabel label="extras" />
                                            <span>{` (${basketExtras.length})`}</span>
                                        </Type.Strong>
                                        <IconWrapper.ToggleIconWrapper isDown={showExtras}>
                                            <Icon variant="chevronDown" />
                                        </IconWrapper.ToggleIconWrapper>
                                    </Styles.Title>
                                    <Styles.Panel visible={showExtras}>
                                        {categories.map((category) => (
                                            <CategorizedExtras
                                                key={category.id}
                                                categorizedExtra={category}
                                                basketExtras={basketExtras}
                                                onRemoveExtra={removeExtra}
                                                handleClickOnlyOnIcon
                                                alwaysShowAllExtras
                                                allowRemoving={!passiveSummary}
                                            />
                                        ))}
                                    </Styles.Panel>
                                </>
                            ) : null}

                            <SummarySpecs />

                            <SummaryTaxAndCosts />

                            {/* TODO: @bySebastian how to put whitespace here without changing components? */}
                            <Flex.Col mt={4} />

                            <BottomNavigation />
                        </Flex.Col>

                        {/* Basket */}
                        <Flex.Col display={{ xs: "none", lg: "block" }} width={1 / 3} position="relative" pt={5}>
                            <SidebarWrapper top={NAV_HEIGHT} paddingTop={BasketStyles.BASKET_HEADER_TOP_MARGIN}>
                                <BasketStyles.BasketHeader>
                                    <BasketFinanceTogglePanel />
                                </BasketStyles.BasketHeader>
                                <Basket />
                            </SidebarWrapper>
                        </Flex.Col>
                    </Flex.Row>
                </Container>
            </GreyBackground>
            <GreyBackground pt={4} pb={4}>
                <Container>
                    <DisclaimerContainer showGenericFinanceDisclaimer hasDarkBackground />
                </Container>
            </GreyBackground>
        </>
    );
};

export default SummaryContainer;
